import React from "react";

import { Modal, Typography } from "@samskip/frontend-components";
import { Trans, useTranslation } from "react-i18next";

type RemoveCargoModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: (willChristmasPackageBeChecked: boolean) => void;
  willChristmasPackageBeChecked: boolean;
};

const RemoveCargoModal = ({
  isOpen,
  onCancel,
  onSubmit,
  willChristmasPackageBeChecked,
}: RemoveCargoModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      closeIcon
      divided
      onClose={onCancel}
      open={isOpen}
      primaryButtonProps={{
        children: t(
          willChristmasPackageBeChecked
            ? "LABEL_CHRISTMAS_PACKAGE_TURN_ON_SUBMIT"
            : "LABEL_CHRISTMAS_PACKAGE_TURN_OFF_SUBMIT"
        ),
        onClick: () => onSubmit(willChristmasPackageBeChecked),
      }}
      secondaryButtonProps={{ children: t("LABEL_CANCEL"), onClick: onCancel }}
      title={t(
        willChristmasPackageBeChecked
          ? "LABEL_CHRISTMAS_PACKAGE_TURN_ON_TITLE"
          : "LABEL_CHRISTMAS_PACKAGE_TURN_OFF_TITLE"
      )}
    >
      <Typography color="neutral-900" variant="body-s">
        <Trans
          components={{ bold: <strong /> }}
          i18nKey={
            willChristmasPackageBeChecked
              ? "INFO_CHRISTMAS_PACKAGE_TURN_ON"
              : "INFO_CHRISTMAS_PACKAGE_TURN_OFF"
          }
        />
      </Typography>
    </Modal>
  );
};

export default RemoveCargoModal;
